import { useLocation } from 'react-router-dom';

export const useQueryParam: (name: string) => string | null = (name: string) => {
    const { search } = useLocation();
    const urlParams = new URLSearchParams(search);
    return urlParams.get(name);
};
